import t from 'react-translate';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import prodPathReplace from 'shared/prod-path-rewrite';


type ExpressInterestSuccessModalProps = {
  onClose: () => void;
  programName: string;
};

const ExpressInterestSuccessModal = ({
  onClose,
  programName,
}: ExpressInterestSuccessModalProps) => (
  <NvModal
    width={460}
    height='unset'
    type={ModalType.FIXED}
    headerBgColor='transparent'
    onClose={onClose}
    header=''
    body={(
      <div className='d-flex flex-column align-items-center text-center'>
        <img src={prodPathReplace('images/all-done.svg')} alt='' />
        <div className='w-100 pt-5'>
          <div className='heading-3 mb-2'>{t.MENTORING_PROGRAMS.FLYER.SUCCESS_MODAL.YOURE_ON_THE_LIST()}</div>
          <div className='text-regular'>{t.MENTORING_PROGRAMS.FLYER.SUCCESS_MODAL.THANKS(programName)}</div>
        </div>
        <div className='w-100 bg-color-green-05 mt-2 p-2 border-radius-1'>
          <div className='heading-4 mb-2 color-success'>{t.MENTORING_PROGRAMS.FLYER.SUCCESS_MODAL.WHATS_NEXT()}</div>
          <div className='text-regular'>{t.MENTORING_PROGRAMS.FLYER.SUCCESS_MODAL.WHATS_NEXT_CONTENT()}</div>
        </div>
      </div>
    )}
  />
);

export default ExpressInterestSuccessModal;
